export const handleGrowlNotification = {
  type: 'function',
  required: true,
}

export const growlNotification = (
  type: string,
  message: string,
  title = '',
) => {
  if (!$.growl) {
    return
  }

  switch (type) {
    case 'warning':
      $.growl.warning({ title, message })
      break
    case 'notice':
      $.growl.notice({ title, message })
      break
    case 'error':
      $.growl.error({ title, message })
      break
    default:
      $.growl({ title, message })
  }
}
